import { cn } from '@/lib/utils'

export type InputFieldProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  type?: 'text' | 'date' | 'number'
  min?: number
  step?: number
  error?: string
  layout?: 'stacked' | 'inline'
  className?: string
}

export const InputField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  min,
  step,
  error,
  layout = 'stacked',
  className,
}: InputFieldProps) => {
  const isInline = layout === 'inline'

  return (
    <div
      className={cn(
        isInline ? 'flex flex-row items-center gap-4' : 'flex flex-col gap-2',
        className
      )}
    >
      <label
        htmlFor={id}
        className={cn(
          'text-sm font-semibold text-foreground',
          isInline && 'w-44 shrink-0'
        )}
      >
        {label}
      </label>

      <div className={cn('flex min-w-0 flex-col gap-2', isInline && 'flex-1')}>
        <input
          id={id}
          type={type}
          value={value}
          min={min}
          step={step}
          placeholder={placeholder}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={Boolean(error)}
          className="w-full rounded-button-sm border border-foreground/10 bg-surface-muted px-4 py-4 text-sm text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-primary-focus focus:ring-2 focus:ring-primary-focus/30"
        />

        {error ? (
          <p className="text-sm text-destructive" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  )
}
